import Debugger from "./Debugger";

export default {
  Debugger
};
